export default "__VITE_ASSET__CWeZNTw0__"